/* mr.js - Mengenrechner.

   Rechnet aus Personenzahl und Anlass die Fleischmenge aus und sucht dazu die
   Packungsgroessen, die am besten passen. Gewichte und Preise kommen aus dem
   JSON-Block der Section und damit direkt aus Shopify.

   Aufbau der Oberflaeche folgt dem Entwurf: links Eingaben, rechts Ergebnis
   mit Mengenbalken, Einkaufsliste, Summe und Versandfortschritt.

   Ohne dieses Skript bleibt der Beitrag lesbar: Richtwerte, Antworten und
   Tabelle stehen als Text in der Seite. Nur das Ausrechnen faellt weg. */
(function () {
  'use strict';

  var D = null, zustand = null;
  var MEHRFACH = ['brotzeit', 'grill', 'vorrat'];

  function $(sel, w) { return (w || document).querySelector(sel); }
  function $$(sel, w) { return Array.prototype.slice.call((w || document).querySelectorAll(sel)); }
  function eur(cent) { return (cent / 100).toFixed(2).replace('.', ',') + ' €'; }
  function kg(gramm) {
    if (gramm >= 1000) return (Math.round(gramm / 100) / 10).toFixed(1).replace('.', ',') + ' kg';
    return Math.round(gramm / 10) * 10 + ' g';
  }
  function text(el, s) { if (el) el.textContent = s; }

  function anlass(k) { for (var i = 0; i < D.anlaesse.length; i++) if (D.anlaesse[i].k === k) return D.anlaesse[i]; return null; }
  function optionen(k) { return D.optionen.filter(function (o) { return o.anlass === k; }); }
  function werte(k) {
    var raus = [];
    optionen(k).forEach(function (o) { if (raus.indexOf(o.wert) === -1) raus.push(o.wert); });
    return raus;
  }
  function istMix(k) { return MEHRFACH.indexOf(k) > -1; }

  /* ---- Mischung --------------------------------------------------------
     Mehrere Sorten kommen zusammen auf den Tisch. Statt sie gleich zu teilen,
     stellst du den Anteil selbst ein. Null Prozent heisst: faellt raus. */

  function mixStart(k) {
    var w = werte(k), n = w.length;
    var grund = Math.floor(100 / n / 10) * 10;
    var rest = 100 - grund * n;
    var m = {};
    w.forEach(function (x, i) { m[x] = grund + (i === 0 ? rest : 0); });
    return m;
  }

  function mixSchieben(k, wert, schritt) {
    var m = zustand.mix[k], keys = Object.keys(m);
    if (schritt > 0) {
      if (m[wert] >= 100) return;
      var geber = keys.filter(function (x) { return x !== wert && m[x] > 0; })
                      .sort(function (a, b) { return m[b] - m[a]; })[0];
      if (!geber) return;
      m[geber] -= 10; m[wert] += 10;
    } else {
      if (m[wert] <= 0) return;
      var nehmer = keys.filter(function (x) { return x !== wert; })
                       .sort(function (a, b) { return m[b] - m[a]; })[0];
      if (!nehmer) return;
      m[wert] -= 10; m[nehmer] += 10;
    }
    zustand.mengen = {};
    mixZeigen(k);
  }

  function mixZeigen(k) {
    var m = zustand.mix[k];
    if (!m) return;
    Object.keys(m).forEach(function (wert) {
      var id = k + ':' + wert;
      var bar = $('[data-mr-mixbar="' + id + '"]');
      if (bar) bar.style.width = m[wert] + '%';
      text($('[data-mr-mixwert="' + id + '"]'), m[wert] + ' %');
      var pos = $('[data-mr-mixpos="' + id + '"]');
      if (pos) pos.setAttribute('data-an', m[wert] > 0 ? '1' : '0');
      $$('[data-mr-mix="' + id + '"]').forEach(function (b) {
        var s = parseInt(b.getAttribute('data-mr-schritt'), 10);
        b.disabled = s < 0 ? m[wert] <= 0 : m[wert] >= 100;
      });
    });
  }

  function aktiveWerte() {
    var k = zustand.anlass;
    if (!istMix(k)) return zustand.wahl;
    var m = zustand.mix[k] || {};
    return Object.keys(m).filter(function (x) { return m[x] > 0; });
  }

  /* ---- Zielmenge ------------------------------------------------------- */

  function ziel() {
    var a = anlass(zustand.anlass);
    if (zustand.anlass === 'vorrat') {
      var mahlzeiten = zustand.haushalt * zustand.proWoche * zustand.wochen;
      return { g: mahlzeiten * a.basis, mahlzeiten: mahlzeiten };
    }
    var personen = zustand.adults + a.kind * zustand.kids;
    var g = personen * a.basis;

    if (zustand.appetit === 'ordentlich') g *= 1.25;
    if (zustand.beilagen === 'viele') g *= 0.85;

    /* Beim Raclette saettigen Kaese, Kartoffeln und Gemuese kraeftig mit.
       Deshalb liegt die Menge dort tiefer als beim Fondue. */
    if (zustand.anlass === 'fondue') {
      if (zustand.wahl.indexOf('raclette') > -1) g *= 175 / 225;
      else if (zustand.fett === 'oel') g *= 200 / 225;
    }

    /* Mit Knochen isst du einen guten Teil des Gewichts nicht mit. */
    if (zustand.anlass === 'festtag' && zustand.knochen) g *= 1.55;

    if (zustand.anlass === 'grill' && zustand.rolle === 'snack') g *= 200.0 / 350.0;
    if (zustand.anlass === 'brotzeit') {
      g *= ({ fruehstueck: 0.8, abendbrot: 1, buffet: 0.9, feier: 1.2 })[zustand.gelegenheit] || 1;
    }
    if (zustand.reste) g *= 2;
    return { g: g, personen: personen };
  }

  /* ---- Packungen suchen ------------------------------------------------ */

  function packung(pid, bedarfG, stueckG) {
    var p = D.produkte[pid];
    if (!p) return null;
    var vs = (p.varianten || []).filter(Boolean);
    if (!vs.length) return null;

    if (stueckG > 0) {
      var stueck = Math.max(1, Math.round(bedarfG / stueckG));
      bedarfG = stueck * stueckG;
    }

    /* Beste Kombination aus einer Groesse und einer Menge: alles ab 92 Prozent
       des Bedarfs zaehlt, gewertet wird der Abstand nach oben. */
    var beste = null;
    vs.forEach(function (v) {
      for (var q = 1; q <= 8; q++) {
        var gesamt = v.kg * 1000 * q;
        if (gesamt < bedarfG * 0.92) continue;
        var abstand = gesamt - bedarfG;
        if (!beste || abstand < beste.abstand - 1 || (Math.abs(abstand - beste.abstand) <= 1 && q < beste.qty)) {
          beste = { v: v, qty: q, gesamt: gesamt, abstand: abstand };
        }
        break;
      }
    });
    if (!beste) {
      var groesste = vs.slice().sort(function (a, b) { return b.kg - a.kg; })[0];
      var q2 = Math.max(1, Math.ceil(bedarfG / (groesste.kg * 1000)));
      beste = { v: groesste, qty: q2, gesamt: groesste.kg * 1000 * q2, abstand: 0 };
    }
    return { pid: pid, produkt: p, variante: beste.v, qty: beste.qty, gesamt: beste.gesamt, bedarf: bedarfG,
             stueck: stueckG > 0 ? Math.round(beste.gesamt / stueckG) : 0 };
  }

  function bauen() {
    var t = ziel();
    var k = zustand.anlass;
    var gewaehlt = aktiveWerte();
    var teile = optionen(k).filter(function (o) { return gewaehlt.indexOf(o.wert) > -1; });
    if (!teile.length) return { t: t, zeilen: [], gesamtG: 0, cent: 0, deckung: 0 };

    var mix = istMix(k) ? zustand.mix[k] : null;
    var proWahl = gewaehlt.length ? 1 / gewaehlt.length : 1;

    var zeilen = [];
    teile.forEach(function (o) {
      var teil = mix ? mix[o.wert] / 100 : proWahl;
      var bedarf = t.g * o.anteil * teil * (o.faktor || 1);
      var z = packung(o.produkt, bedarf, o.stueck);
      if (!z) return;
      z.gruppe = o.name;
      /* Von Hand gesetzte Mengen bleiben stehen, bis der Anlass wechselt. */
      var schluessel = k + ':' + o.wert + ':' + o.produkt;
      z.schluessel = schluessel;
      z.weg = !!zustand.weg[schluessel];
      if (!z.weg && zustand.mengen[schluessel] != null) {
        z.qty = zustand.mengen[schluessel];
        z.gesamt = z.variante.kg * 1000 * z.qty;
        if (o.stueck) z.stueck = Math.round(z.gesamt / o.stueck);
      }
      zeilen.push(z);
    });
    var aktiv = zeilen.filter(function (z) { return !z.weg; });
    var gesamtG = aktiv.reduce(function (a, z) { return a + z.gesamt; }, 0);
    var cent = aktiv.reduce(function (a, z) { return a + z.variante.cent * z.qty; }, 0);
    return { t: t, zeilen: zeilen, aktiv: aktiv, gesamtG: gesamtG, cent: cent, deckung: t.g ? gesamtG / t.g : 0 };
  }

  /* ---- Anzeige --------------------------------------------------------- */

  function satz() {
    if (zustand.anlass === 'vorrat') {
      return 'Für ' + zustand.haushalt + (zustand.haushalt === 1 ? ' Person' : ' Personen') +
             ', ' + zustand.proWoche + ' Fleischtage pro Woche und ' + zustand.wochen +
             (zustand.wochen === 1 ? ' Woche' : ' Wochen') + ' brauchst du etwa';
    }
    var s = 'Für ' + zustand.adults + (zustand.adults === 1 ? ' Erwachsenen' : ' Erwachsene');
    if (zustand.kids) s += ' und ' + zustand.kids + (zustand.kids === 1 ? ' Kind' : ' Kinder');
    return s + ' brauchst du etwa';
  }

  function knopf(label, aria, attr, wert) {
    var b = document.createElement('button');
    b.type = 'button';
    b.setAttribute('aria-label', aria);
    b.setAttribute(attr, wert);
    b.textContent = label;
    return b;
  }

  function zeile(z) {
    var li = document.createElement('li');
    var name = z.produkt.titel || z.produkt.name;

    if (z.weg) {
      li.className = 'mr-pos mr-pos--weg';
      var w = document.createElement('span');
      w.textContent = name + ' entfernt';
      var zurueck = knopf('Rückgängig', 'Entfernen rückgängig machen für ' + name, 'data-mr-zurueck', z.schluessel);
      zurueck.className = 'mr-tlink';
      li.appendChild(w); li.appendChild(zurueck);
      return li;
    }

    li.className = 'mr-pos';

    var bild = document.createElement('a');
    bild.className = 'mr-pos__bild';
    bild.href = z.produkt.url;
    bild.setAttribute('tabindex', '-1');
    bild.setAttribute('aria-hidden', 'true');
    if (z.produkt.bild) {
      var img = document.createElement('img');
      img.src = z.produkt.bild; img.alt = ''; img.loading = 'lazy';
      bild.appendChild(img);
    }
    li.appendChild(bild);

    var mitte = document.createElement('div');
    mitte.className = 'mr-pos__mitte';

    var a1 = document.createElement('a');
    a1.className = 'mr-pos__name';
    a1.href = z.produkt.url;
    a1.textContent = name;
    mitte.appendChild(a1);

    var m = document.createElement('span');
    m.className = 'mr-pos__menge';
    var teile = [];
    teile.push(z.qty + ' × ' + z.variante.titel.replace(/^Default Title$/, kg(z.variante.kg * 1000)));
    if (z.stueck) teile.push(z.stueck + ' Stück');
    teile.push(kg(z.gesamt) + ' gesamt');
    m.textContent = teile.join(' · ');
    mitte.appendChild(m);

    var tasten = document.createElement('span');
    tasten.className = 'mr-pos__tasten';
    var raus = knopf('Entfernen', name + ' aus der Liste entfernen', 'data-mr-weg', z.schluessel);
    raus.className = 'mr-tlink mr-tlink--leise';
    tasten.appendChild(raus);
    mitte.appendChild(tasten);
    li.appendChild(mitte);

    var rechts = document.createElement('div');
    rechts.className = 'mr-pos__rechts';

    var st = document.createElement('div');
    st.className = 'mr-qty';
    st.setAttribute('role', 'group');
    st.setAttribute('aria-label', 'Menge ' + name);
    var minus = knopf('−', 'Eine Packung weniger ' + name, 'data-mr-menge-step', '-1');
    minus.setAttribute('data-mr-schluessel', z.schluessel);
    minus.disabled = z.qty <= 1;
    var zahl = document.createElement('span');
    zahl.setAttribute('aria-live', 'polite');
    zahl.textContent = z.qty + ' ×';
    var plus = knopf('+', 'Eine Packung mehr ' + name, 'data-mr-menge-step', '1');
    plus.setAttribute('data-mr-schluessel', z.schluessel);
    st.appendChild(minus); st.appendChild(zahl); st.appendChild(plus);
    rechts.appendChild(st);

    var pr = document.createElement('b');
    pr.className = 'mr-pos__preis';
    pr.textContent = eur(z.variante.cent * z.qty);
    rechts.appendChild(pr);
    li.appendChild(rechts);

    return li;
  }

  function zeigen() {
    var e = bauen(), a = anlass(zustand.anlass);
    var aktiv = e.aktiv || [];

    text($('[data-mr-satz]'), satz());
    text($('[data-mr-menge]'), kg(Math.round(e.t.g / 10) * 10));

    var dazu = 'Rohgewicht, also vor dem Garen';
    if (zustand.anlass === 'festtag') dazu = zustand.knochen ? 'Rohgewicht mit Knochen' : 'Rohgewicht ohne Knochen';
    else if (zustand.anlass === 'vorrat') dazu = 'für ' + e.t.mahlzeiten + ' Mahlzeiten in ' + zustand.wochen + (zustand.wochen === 1 ? ' Woche' : ' Wochen');
    text($('[data-mr-dazu]'), dazu);

    text($('[data-mr-notiz]'), a.notiz);
    text($('[data-mr-tipp]'), '„' + a.tipp + '“');

    var box = $('[data-mr-balkenbox]');
    if (aktiv.length && e.t.g) {
      box.hidden = false;
      var d = e.deckung;
      /* Packungsgroessen runden auf. Liegt die Liste deutlich ueber dem
         Ziel, sagen wir warum, sonst wirkt die Zahl wie ein Rechenfehler. */
      var lage = d < 0.95 ? 'knapp bemessen'
               : d <= 1.15 ? 'passt genau'
               : d <= 1.4 ? 'großzügig, mit Reserve'
               : 'mehr als nötig, weil die Packungsgrößen aufrunden';
      $('[data-mr-balken]').style.width = Math.round(Math.min(1, d / 1.5) * 100) + '%';
      text($('[data-mr-zielmenge]'), 'Ziel: ' + kg(Math.round(e.t.g / 10) * 10));
      var p = $('[data-mr-proportion]');
      p.textContent = '';
      var b = document.createElement('b');
      b.textContent = 'Deine Liste: ' + kg(e.gesamtG);
      p.appendChild(b);
      p.appendChild(document.createTextNode(' · ' + lage));
    } else { box.hidden = true; }

    var liste = $('[data-mr-liste]');
    liste.textContent = '';
    e.zeilen.forEach(function (z) { liste.appendChild(zeile(z)); });

    var summe = $('[data-mr-summe]'), versandbox = $('[data-mr-versandbox]');
    var kauf = $('[data-mr-kaufen]'), werkzeuge = $('[data-mr-werkzeuge]');
    var sticky = $('[data-mr-sticky]');

    if (aktiv.length) {
      summe.hidden = false; versandbox.hidden = false;
      werkzeuge.hidden = false; kauf.hidden = false; kauf.disabled = false;

      text($('[data-mr-preis]'), eur(e.cent));
      text($('[data-mr-umfang]'), kg(e.gesamtG) + ' · ' + aktiv.length + (aktiv.length === 1 ? ' Produkt' : ' Produkte'));
      var koepfe = zustand.anlass === 'vorrat' ? e.t.mahlzeiten : (zustand.adults + zustand.kids);
      text($('[data-mr-proPerson]'), koepfe
        ? 'ca. ' + eur(Math.round(e.cent / koepfe)) + ' pro ' + (zustand.anlass === 'vorrat' ? 'Mahlzeit' : 'Person')
        : '');

      var fehlt = D.versandfrei - e.cent;
      text($('[data-mr-versand]'), fehlt > 0 ? 'Noch ' + eur(fehlt) + ' bis versandkostenfrei' : 'Versand geht auf uns.');
      $('[data-mr-versandbahn]').style.width = Math.min(100, e.cent / D.versandfrei * 100) + '%';

      text($('[data-mr-sticky-menge]'), kg(Math.round(e.t.g / 10) * 10));
      text($('[data-mr-sticky-preis]'), ' · ca. ' + eur(e.cent));
      if (sticky) sticky.dataset.bereit = '1';
    } else {
      summe.hidden = true; versandbox.hidden = true;
      werkzeuge.hidden = true; kauf.hidden = true;
      if (sticky) { sticky.dataset.bereit = ''; sticky.hidden = true; }
    }
    truhe(e);
    tabellen();
    zustand.letzte = e;
    stickyPruefen();
  }

  /* ---- Platz in der Truhe ----------------------------------------------
     Ein Kilo Fleisch braucht rund anderthalb Liter, vakuumiert etwas
     weniger. Dieselbe Zahl steht in den haeufigen Fragen. */

  var LITER_JE_KG = 1.5;

  function truhe(e) {
    var box = $('[data-mr-truhe]');
    if (!box) return;
    if (zustand.anlass !== 'vorrat' || !e.aktiv || !e.aktiv.length) { box.hidden = true; return; }
    box.hidden = false;

    var raster = $('[data-mr-wochenraster]');
    raster.textContent = '';
    for (var w = 0; w < zustand.wochen; w++) {
      var kasten = document.createElement('div');
      kasten.className = 'mr-woche';
      var titel = document.createElement('b');
      titel.textContent = 'Woche ' + (w + 1);
      var tage = document.createElement('div');
      for (var d = 0; d < 7; d++) {
        var punkt = document.createElement('i');
        if (d < zustand.proWoche) punkt.className = 'an';
        tage.appendChild(punkt);
      }
      kasten.appendChild(titel); kasten.appendChild(tage);
      raster.appendChild(kasten);
    }

    var noetig = Math.round(e.gesamtG / 1000 * LITER_JE_KG);
    var frei = parseInt(zustand.liter, 10);
    var satz = e.t.mahlzeiten + ' Portionen à ca. ' + anlass('vorrat').basis + ' g. Gold sind die Fleischtage. ' +
               'Platzbedarf: rund ' + noetig + ' Liter.';
    if (!isNaN(frei) && frei > 0) {
      satz += frei >= noetig
        ? ' Bei ' + frei + ' Litern frei passt das.'
        : ' Bei ' + frei + ' Litern frei wird es eng, plane kleiner oder in zwei Etappen.';
    }
    text($('[data-mr-truhe-text]'), satz);
  }

  /* ---- Tabellen folgen der Auswahl --------------------------------------
     Welche Zeile der Richtwerte gerade gilt, haengt je Anlass an einer
     anderen Eingabe: beim Braten am Stueck und am Knochen, beim Fondue an
     Raclette oder Oel, bei der Brotzeit an der Gelegenheit, beim Grillen an
     Hauptgang oder Snack. Der Vorrat hat keine solche Zeile. */

  function aktiveZeile() {
    var k = zustand.anlass;
    if (k === 'festtag') return zustand.knochen ? 'knochen' : zustand.wahl[0];
    if (k === 'fondue') {
      if (zustand.wahl.indexOf('raclette') > -1) return 'raclette';
      return zustand.fett === 'oel' ? 'oel' : 'fondue';
    }
    if (k === 'schmor') return zustand.wahl[0];
    if (k === 'brotzeit') return zustand.gelegenheit;
    if (k === 'grill') return zustand.rolle;
    return null;
  }

  function tabellen() {
    var k = zustand.anlass;
    var block = $('[data-mr-rw="' + k + '"]');
    if (!block) return;
    var schluessel = aktiveZeile();

    var zeile = null;
    $$('tr[data-mr-zeile]', block).forEach(function (tr) {
      var an = schluessel && tr.getAttribute('data-mr-zeile') === schluessel;
      if (an) { tr.setAttribute('aria-current', 'true'); zeile = tr; }
      else tr.removeAttribute('aria-current');
    });
    if (!zeile) { text($('[data-mr-anzahl]'), anlass(k).richtwert); return; }

    var name = zeile.getAttribute('data-mr-name');
    text($('[data-mr-gericht]', block), name);

    /* Die Zeile neben der Einkaufsliste nennt dasselbe Gericht mit seiner
       Menge, damit Liste und Tabelle dieselbe Sprache sprechen. */
    var proKopf = zeile.children[1] ? zeile.children[1].textContent.trim() : '';
    text($('[data-mr-anzahl]'), proKopf ? name + ': ' + proKopf + ' pro Person' : '');

    var lo = parseInt(zeile.getAttribute('data-mr-lo'), 10);
    var hi = parseInt(zeile.getAttribute('data-mr-hi'), 10);
    var einheit = zeile.getAttribute('data-mr-einheit');
    if (isNaN(lo)) return;

    $$('[data-mr-gaeste]', block).forEach(function (td) {
      var n = parseInt(td.getAttribute('data-mr-gaeste'), 10);
      if (einheit === 'stueck') {
        var st = lo * n;
        td.textContent = st + (st === 1 ? ' Stück' : ' Stück');
        return;
      }
      var a = kg(lo * n), b = kg(hi * n);
      td.textContent = a === b ? a : a + ' bis ' + b;
    });
  }

  /* ---- Oberflaeche ----------------------------------------------------- */

  function sichtbarkeit() {
    var k = zustand.anlass;
    $$('[data-mr-nur]').forEach(function (el) {
      var w = el.getAttribute('data-mr-nur');
      el.hidden = !(w === k || (w === 'nicht-vorrat' && k !== 'vorrat'));
    });
    $$('[data-mr-auswahl]').forEach(function (el) { el.hidden = el.getAttribute('data-mr-auswahl') !== k; });
    $$('[data-mr-antwort]').forEach(function (el) { el.hidden = el.getAttribute('data-mr-antwort') !== k; });
    $$('[data-mr-rw]').forEach(function (el) { el.hidden = el.getAttribute('data-mr-rw') !== k; });
    $$('[data-mr-mehr]').forEach(function (el) { el.hidden = el.getAttribute('data-mr-mehr') !== k; });
    var fettbox = $('[data-mr-fett]');
    if (fettbox) fettbox.hidden = !(k === 'fondue' && zustand.wahl.indexOf('fondue') > -1);
    $$('[data-mr-anlass]').forEach(function (b) {
      b.setAttribute('aria-pressed', b.getAttribute('data-mr-anlass') === k ? 'true' : 'false');
    });
  }

  function wahlSetzen(wert) {
    var k = zustand.anlass;
    if (istMix(k)) {
      /* Tiefenlink auf eine Sorte: die bekommt das Gewicht, der Rest bleibt. */
      var m = zustand.mix[k];
      if (m && m[wert] === 0) mixSchieben(k, wert, 10);
      return;
    }
    zustand.wahl = [wert];
    zustand.mengen = {}; zustand.weg = {};
    var fettbox = $('[data-mr-fett]');
    if (fettbox) fettbox.hidden = !(k === 'fondue' && wert === 'fondue');
    $$('[data-mr-opt="' + k + '"]').forEach(function (b) {
      b.setAttribute('aria-pressed', b.getAttribute('data-mr-wert') === wert ? 'true' : 'false');
    });
  }

  function anlassSetzen(k) {
    zustand.anlass = k;
    zustand.mengen = {}; zustand.weg = {};
    var alle = werte(k);
    if (istMix(k)) {
      if (!zustand.mix[k]) zustand.mix[k] = mixStart(k);
      zustand.wahl = alle.slice();
      mixZeigen(k);
    } else {
      zustand.wahl = [alle[0]];
      $$('[data-mr-opt="' + k + '"]').forEach(function (b) {
        b.setAttribute('aria-pressed', b.getAttribute('data-mr-wert') === alle[0] ? 'true' : 'false');
      });
    }
    sichtbarkeit();
    zeigen();
  }

  function gruppeSetzen(attr, wert, feld, wandeln) {
    zustand[feld] = wandeln ? wandeln(wert) : wert;
    $$('[' + attr + ']').forEach(function (b) {
      b.setAttribute('aria-pressed', b.getAttribute(attr) === wert ? 'true' : 'false');
    });
    zustand.mengen = {};
    zeigen();
  }

  /* ---- Sticky-Leiste auf dem Telefon ----------------------------------- */

  function stickyPruefen() {
    var leiste = $('[data-mr-sticky]');
    var liste = $('#mr-liste');
    var rechner = $('#rechner');
    if (!leiste || !liste || !rechner) return;
    if (!leiste.dataset.bereit || window.innerWidth > 1023) { leiste.hidden = true; return; }
    var r = rechner.getBoundingClientRect();
    var l = liste.getBoundingClientRect();
    var imBlick = r.top < window.innerHeight - 60 && r.bottom > 80;
    leiste.hidden = !(imBlick && l.top > window.innerHeight - 40);
  }

  function binden() {
    document.addEventListener('click', function (ev) {
      var t = ev.target.closest ? ev.target.closest('button') : null;
      if (!t) return;

      if (t.hasAttribute('data-mr-anlass')) { anlassSetzen(t.getAttribute('data-mr-anlass')); return; }
      if (t.hasAttribute('data-mr-wert')) { wahlSetzen(t.getAttribute('data-mr-wert')); zeigen(); return; }
      if (t.hasAttribute('data-mr-appetit')) { gruppeSetzen('data-mr-appetit', t.getAttribute('data-mr-appetit'), 'appetit'); return; }
      if (t.hasAttribute('data-mr-beilagen')) { gruppeSetzen('data-mr-beilagen', t.getAttribute('data-mr-beilagen'), 'beilagen'); return; }
      if (t.hasAttribute('data-mr-rolle')) { gruppeSetzen('data-mr-rolle', t.getAttribute('data-mr-rolle'), 'rolle'); return; }
      if (t.hasAttribute('data-mr-gel')) { gruppeSetzen('data-mr-gel', t.getAttribute('data-mr-gel'), 'gelegenheit'); return; }
      if (t.hasAttribute('data-mr-fett')) {
        gruppeSetzen('data-mr-fett', t.getAttribute('data-mr-fett'), 'fett');
        text($('[data-mr-fett-hilfe]'), zustand.fett === 'oel'
          ? 'In Öl gart es schneller und macht schneller satt, dort reichen 200 g.'
          : 'In Brühe bleibt es mager, und die Brühe gibt es am Ende als Suppe.');
        return;
      }
      if (t.hasAttribute('data-mr-wochen')) {
        gruppeSetzen('data-mr-wochen', t.getAttribute('data-mr-wochen'), 'wochen', function (v) { return parseInt(v, 10); });
        return;
      }
      if (t.hasAttribute('data-mr-knochen')) {
        gruppeSetzen('data-mr-knochen', t.getAttribute('data-mr-knochen'), 'knochen', function (v) { return v === '1'; });
        return;
      }

      if (t.hasAttribute('data-mr-mix')) {
        var id = t.getAttribute('data-mr-mix').split(':');
        mixSchieben(id[0], id[1], parseInt(t.getAttribute('data-mr-schritt'), 10));
        zeigen();
        return;
      }

      if (t.hasAttribute('data-mr-reste-auf')) {
        t.hidden = true;
        var kasten = $('[data-mr-reste-box]');
        kasten.hidden = false;
        var hk = $('input', kasten);
        if (hk) hk.focus();
        return;
      }

      if (t.hasAttribute('data-mr-step')) {
        var feld = document.getElementById(t.getAttribute('data-mr-ziel'));
        var neu = (parseInt(feld.value, 10) || 0) + parseInt(t.getAttribute('data-mr-step'), 10);
        neu = Math.max(parseInt(feld.min, 10), Math.min(parseInt(feld.max, 10), neu));
        feld.value = neu;
        zustand[feld.getAttribute('data-mr-feld')] = neu;
        zustand.mengen = {};
        zeigen();
        return;
      }

      if (t.hasAttribute('data-mr-menge-step')) {
        var sl = t.getAttribute('data-mr-schluessel');
        var jetzt = null;
        (zustand.letzte ? zustand.letzte.zeilen : []).forEach(function (z) { if (z.schluessel === sl) jetzt = z.qty; });
        if (jetzt == null) return;
        zustand.mengen[sl] = Math.max(1, Math.min(20, jetzt + parseInt(t.getAttribute('data-mr-menge-step'), 10)));
        zeigen();
        return;
      }

      if (t.hasAttribute('data-mr-weg')) { zustand.weg[t.getAttribute('data-mr-weg')] = true; zeigen(); return; }
      if (t.hasAttribute('data-mr-zurueck')) { delete zustand.weg[t.getAttribute('data-mr-zurueck')]; zeigen(); return; }
      if (t.hasAttribute('data-mr-zurliste')) { zurListe(); return; }
      if (t.hasAttribute('data-mr-drucken')) { window.print(); return; }
      if (t.hasAttribute('data-mr-teilen')) { teilen(t); return; }
      if (t.hasAttribute('data-mr-kaufen')) { kaufen(t); return; }
    });

    $$('input[data-mr-feld]').forEach(function (inp) {
      inp.addEventListener('change', function () {
        var f = inp.getAttribute('data-mr-feld');
        if (inp.type === 'checkbox') zustand[f] = inp.checked;
        else if (inp.type !== 'number') {
          inp.value = inp.value.replace(/\D/g, '').slice(0, 4);
          zustand[f] = inp.value;
        } else {
          var n = parseInt(inp.value, 10);
          if (isNaN(n)) n = parseInt(inp.min, 10);
          n = Math.max(parseInt(inp.min, 10), Math.min(parseInt(inp.max, 10), n));
          inp.value = n; zustand[f] = n;
        }
        zustand.mengen = {};
        zeigen();
      });
      inp.addEventListener('input', function () { if (inp.type !== 'checkbox') inp.dispatchEvent(new Event('change')); });
    });

    window.addEventListener('scroll', stickyPruefen, { passive: true });
    window.addEventListener('resize', stickyPruefen, { passive: true });
  }

  function sanft() { return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'; }

  function zurListe() {
    var l = $('#mr-liste');
    if (l) l.scrollIntoView({ block: 'start', behavior: sanft() });
  }

  function teilen(btn) {
    var u = window.location.origin + window.location.pathname + '?anlass=' + zustand.anlass;
    var fertig = function () {
      var alt = btn.getAttribute('data-alt') || btn.textContent;
      btn.setAttribute('data-alt', alt);
      btn.textContent = 'Link kopiert';
      setTimeout(function () { btn.textContent = alt; }, 2500);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(u).then(fertig, function () {});
    }
  }

  function kaufen(btn) {
    var e = zustand.letzte;
    var aktiv = e && e.aktiv ? e.aktiv : [];
    if (!aktiv.length) return;
    btn.disabled = true;
    btn.textContent = 'Wird hinzugefügt …';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: aktiv.map(function (z) { return { id: z.variante.id, quantity: z.qty }; }) })
    }).then(function (r) { return r.json(); }).then(function () {
      btn.textContent = 'Liegt im Warenkorb';
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      setTimeout(function () { btn.disabled = false; btn.textContent = 'Alles in den Warenkorb'; }, 4000);
    }).catch(function () {
      btn.disabled = false;
      btn.textContent = 'Hat nicht geklappt, nochmal versuchen';
    });
  }

  function start() {
    var block = $('[data-mr-daten]');
    if (!block) return;
    try { D = JSON.parse(block.textContent); } catch (e) { return; }
    if (!D || !D.anlaesse || !D.anlaesse.length) return;

    zustand = {
      anlass: D.anlaesse[0].k, wahl: [], mix: {},
      adults: 4, kids: 0, haushalt: 2, proWoche: 3, wochen: 4,
      appetit: 'normal', beilagen: 'wenige', reste: false, knochen: false,
      rolle: 'haupt', gelegenheit: 'abendbrot', fett: 'bruehe', liter: '',
      mengen: {}, weg: {}
    };
    binden();
    anlassSetzen(zustand.anlass);
    ausAdresse();
  }

  /* ---- Tiefenlinks ------------------------------------------------------
     Andere Seiten verlinken gezielt auf einen Anlass, Produktseiten geben
     zusaetzlich ihr Produkt mit. Die Adresse ohne Parameter bleibt das
     Original, der Canonical zeigt immer dorthin. */

  function ausAdresse() {
    var par = new URLSearchParams(window.location.search);
    var wunschAnlass = par.get('anlass');
    var wunschProdukt = par.get('produkt');
    var getroffen = false;

    if (wunschAnlass && anlass(wunschAnlass)) {
      anlassSetzen(wunschAnlass);
      getroffen = true;
    }

    if (wunschProdukt) {
      var pid = null;
      Object.keys(D.produkte).forEach(function (k) {
        var u = D.produkte[k].url || '';
        if (u.indexOf('/products/' + wunschProdukt) === 0) pid = k;
      });
      if (pid) {
        /* Steht ein Anlass dabei, bleibt der stehen. Dasselbe Produkt kommt in
           mehreren Anlaessen vor, die Produktseite weiss am besten, welcher
           gemeint ist. Ohne Anlass nehmen wir den erstbesten Treffer. */
        var treffer = D.optionen.filter(function (o) { return o.produkt === pid; });
        var passend = getroffen ? treffer.filter(function (o) { return o.anlass === zustand.anlass; }) : [];
        var o2 = passend[0] || (getroffen ? null : treffer[0]);
        if (o2) {
          if (!getroffen) anlassSetzen(o2.anlass);
          wahlSetzen(o2.wert);
          zeigen();
          getroffen = true;
        }
      }
    }

    if (getroffen) {
      var z = document.getElementById('rechner');
      if (z) z.scrollIntoView({ block: 'start', behavior: sanft() });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
